/**
     * @desc //17刷新我的盲盒
用于：个人盲盒页面
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, options = {}) {
  return ajax.post('/box/reloadMyUserBox', params);
}

export function upload(params, options = {}) {
  return ajax.upload('/box/reloadMyUserBox', params);
}
